module.exports = __webpack_public_path__ + "img/Logo_White.79281180.svg";